const regexMap = {
    tiktokProfileLink: /^https:\/\/www\.tiktok\.com\/@[\w.]+(?:\?.*)?$/,
    instagramProfileLink: [
        /^https?:\/\/www\.instagram\.com\/[a-zA-Z0-9._]+\/?(\?[^\/]*)?$/,
        /^https?:\/\/www\.instagram\.com\/[a-zA-Z0-9._]+(\/[a-zA-Z0-9._-]+)*(\/?\?[^\/]*)?$/,
    ],
    youtubeChannelLink:
        /^https:\/\/(www\.|m\.)?youtube\.com\/(?!watch|shorts|live)(@[\w#-]+|c\/[\w-]+|channel\/[a-zA-Z0-9_-]+|user\/[\w-]+|[\w-]+)(\/.*)?(\?.*)?$/,
    instagramUsername: /^[a-zA-Z0-9._]{1,30}$/,
    instagramPostLink: [
        /^https?:\/\/(www\.)?instagram\.com\/p\/[A-Za-z0-9_-]+\/?(?:\?.*)?$/,
        /^https:\/\/www\.instagram\.com\/(reels|reel)\/[A-Za-z0-9_-]+\/(\?.+)?$/,
    ],
    instagramStoryLink:
        /^(?:https?:\/\/)?(?:www\.)?instagram\.com\/(?:stories\/highlights|s|stories\/[a-zA-Z0-9._-]+)\/[a-zA-Z0-9._-]+(?:\/)?(?:\?[;&a-zA-Z0-9._~=%-]*)?$/,
    facebookProfileLink: [
        /^(?:https:\/\/)?(?:www\.|m\.)?facebook\.com\/((?!post|video|watch|photo)[a-zA-Z0-9\.]{1,50}(?![a-zA-Z0-9\.])|share\/[a-zA-Z0-9\.]+)\/?(?:[a-zA-Z0-9\?\[\]_=.&%-]*)?$/,
        /^https:\/\/(www\.)?facebook\.com\/(@?[\w.]+)\/?$/,
    ],
    facebookPostLink: [
        /^https?:\/\/(?:www\.)?facebook\.com\/(?:share\/(?:v|p|[a-zA-Z0-9]+)?\/[a-zA-Z0-9]+\/?(?:\?mibextid=[a-zA-Z0-9]+)?|[a-zA-Z0-9.]+\/posts\/[a-zA-Z0-9]+\/?)$/,
        /^https?:\/\/(www\.)?facebook\.com\/share\/[A-Za-z0-9]+\/\?.*$/,
        /^https?:\/\/(www\.)?facebook\.com\/story\.php\?story_fbid=[0-9]+&id=[0-9]+(&[a-zA-Z_]+=.*)*$/,
        /^https?:\/\/(www\.)?facebook\.com\/(photo\/\?fbid=[0-9]+(&set=[^&]+)?|watch\?v=[0-9]+|[0-9]+\/posts\/[0-9]+\/\?.*)$|^https?:\/\/fb\.watch\/[A-Za-z0-9]+\/?$/,
        /^https:\/\/m\.facebook\.com\/(photo\?fbid=[0-9]+(&set=[^&]+)?|[0-9]+\/posts\/[0-9]+\/?)$/,
        /^https:\/\/www\.facebook\.com\/reel\/[0-9]+$/,
        /^https:\/\/www\.facebook\.com\/[a-zA-Z0-9._-]+\/videos(\/pcb\.\d+)?\/\d+\/?$/,
        /^https:\/\/(?:www\.facebook\.com\/(?:watch\/live\/\?ref=watch_permalink&v=\d+|[a-zA-Z0-9._-]+\/videos\/\d+)|fb\.watch\/[a-zA-Z0-9._-]+\/?)$/,
        /^https:\/\/(?:[wm]\.)?facebook\.com\/(?:watch\/live\/\?ref=watch_permalink&v=\d+|[a-zA-Z0-9._-]+\/(?:videos|permalink)\/*\d+|permalink\.php\?story_fbid=\d+&id=\d+|fb\.watch\/[a-zA-Z0-9._-]+\/?)$/,
    ],
    facebookVideoLink: [
        /^https?:\/\/(?:www\.|m\.)?(?:facebook\.com\/(?:share\/(?:v|[a-zA-Z0-9]+)\/[a-zA-Z0-9]{10,}\/?(?:\?mibextid=[a-zA-Z0-9]+)?|share\/[a-zA-Z0-9]+\/?[a-zA-Z0-9]+\/?(?:\?mibextid=[a-zA-Z0-9]+)?|watch\/?(?:\?v=\d+|[a-zA-Z0-9_-]{10,})\/?(?:\?mibextid=[a-zA-Z0-9]+)?|[a-zA-Z0-9.]+\/videos\/(?:\d+\/?|pcb\.\d+\/\d+\/?)|watch\/live\/\?ref=watch_permalink&v=\d+|permalink\.php\?story_fbid=\d+&id=\d+)|fb\.watch\/[a-zA-Z0-9_-]+\/?)$/,
        /^https:\/\/www\.facebook\.com\/reel\/[0-9]+$/,
        /^https:\/\/(?:[wm]\.)?facebook\.com\/(?:watch\/live\/\?ref=watch_permalink&v=\d+|[a-zA-Z0-9._-]+\/(?:videos|permalink)\/*\d+|permalink\.php\?story_fbid=\d+&id=\d+|fb\.watch\/[a-zA-Z0-9._-]+\/?)$/,
    ],
    facebookStoryLink: [
        /^https?:\/\/(?:www\.)?facebook\.com\/stories\/(?:[0-9]+|[a-zA-Z0-9]+)\/[a-zA-Z0-9=_-]+\/?(?:\?[a-zA-Z0-9_&=-]*)?$/,
        /https:\/\/www\.facebook\.com\/share\/[A-Za-z0-9]+(?:\?.*)?/,
    ],
    tiktokUsername: /^[a-zA-Z0-9._]{1,24}$/,
    tiktokPostLink: [
        /^(?:https?:\/\/)?(?:www\.|vt\.)?tiktok\.com\/(@([a-zA-Z0-9._-]{1,24})\/video\/[a-zA-Z0-9]+|ZS[a-zA-Z0-9]+)(\/)?(?:\?.*)?$/,
        /^https?:\/\/vm\.tiktok\.com\/[A-Za-z0-9]+\/?$/,
    ],
    // youtubeChannelName: /^[\w](?!.*?\.{2})[\w.]{0,50}[\w]$/,
    youtubeChannelName: [
        /^[\w#@'_\-&+.!](?!.*?\.{2})[\w#@'_\-&+.!]{0,50}[\w#@'_\-&+.!]$/,
        /^https:\/\/(www\.|m\.)?youtube\.com\/(?!watch|shorts|live)(@[\w]+|c\/[\w-]+|channel\/[a-zA-Z0-9_-]+|user\/[\w-]+|[\w-]+)(\/.*)?(\?.*)?$/,
        /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtu\.be\/|youtube\.com\/(?:watch\?.*v=|embed\/|live\/|shorts\/))([a-zA-Z0-9_-]+)(\?.*)?$/,
    ],
    youtubeVideoLink:
        /^(https?:\/\/)?(www\.|m\.)?(youtu\.be\/|youtube\.com\/(watch\?.*?v=|embed\/|live\/|shorts\/))([a-zA-Z0-9_-]{11})([&?].*)?$/,
    youtubeLivestreamLink:
        /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtu\.be\/|youtube\.com\/(?:watch\?.*v=|embed\/|live\/|\/))(?:[a-zA-Z0-9-._!`'#%&,:;<>=@{}~$()*+?^|]+)$/,
    twitterProfileLink:
        /^(?:https?:\/\/)?(?:www\.)?(twitter\.com|x\.com)\/([a-zA-Z0-9_]+)(?:\/)?(?:[\?]+[;&a-zA-Z0-9_.~+=-]*)?$/,
    twitterPostLink:
        /^https?:\/\/(www\.)?(twitter\.com|x\.com)\/[A-Za-z0-9_]+\/status\/[0-9]+(\?s=[0-9]+)?$/,
    twitterSpacelistenerLink:
        /^https?:\/\/(www\.)?(twitter\.com|x\.com)\/i\/spaces\/[A-Za-z0-9]+(\/peek)?$/,
    threadsProfileLink:
        /^(?:https?:\/\/)?(?:www\.)?threads\.net\/@?([a-zA-Z0-9_.]{1,30})(?:\/)?(?:[\?]+[;&a-zA-Z0-9_.~+=-]*)?$/,
    threadsPostLink:
        /^(?:https?:\/\/)?(?:www\.)?threads\.net\/@?([a-zA-Z0-9_.]{1,30})\/post\/([a-zA-Z0-9-_]+)(?:\/)?(?:\?[;&a-zA-Z0-9_.~+=-]*)?$/,
    instagramReelViews:
        /^https:\/\/www\.instagram\.com\/(reels|reel)\/[A-Za-z0-9_-]+\/(\?.+)?$/,
    youtubeShortviews:
        /^(https:\/\/(www\.)?youtube\.com\/(shorts|watch)\/[A-Za-z0-9_-]+(\?[\w=&_-]+)?)$/,
};
const serviceRegexMap = {
    instagramProfileLink: regexMap.instagramProfileLink,
    tiktokProfileLink: regexMap.tiktokProfileLink,
    youtubeChannelLink: regexMap.youtubeChannelLink,
    instagramUsername: regexMap.instagramUsername,
    instagramStoryviews: regexMap.instagramStoryLink,
    tiktokUsername: regexMap.tiktokUsername,
    facebookProfileLink: regexMap.facebookProfileLink,
    facebookPostlikes: regexMap.facebookPostLink,
    facebookVideoviews: regexMap.facebookVideoLink,
    facebookWatchhours: regexMap.facebookVideoLink,
    facebookStoryviews: regexMap.facebookStoryLink,
    twitterProfileLink: regexMap.twitterProfileLink,
    twitterLikes: regexMap.twitterPostLink,
    twitterRetweets: regexMap.twitterPostLink,
    twitterViews: regexMap.twitterPostLink,
    twitterVotes: regexMap.twitterPostLink,
    twitterSpacelisteners: regexMap.twitterSpacelistenerLink,
    threadsProfileLink: regexMap.threadsProfileLink,
    threadsLikes: regexMap.threadsPostLink,
    youtubeChannelName: regexMap.youtubeChannelName,
    youtubeLivestream: regexMap.youtubeLivestreamLink,
    youtubeViews: regexMap.youtubeVideoLink,
    youtubeViewstargeted: regexMap.youtubeVideoLink,
    youtubeLikes: regexMap.youtubeVideoLink,
    youtubeShare: regexMap.youtubeVideoLink,
    instagramLikes: regexMap.instagramPostLink,
    instagramViews: regexMap.instagramPostLink,
    instagramReelviews: regexMap.instagramReelViews,
    tiktokPost: regexMap.tiktokPostLink,
    youtubeShortviews: regexMap.youtubeShortviews,
};
function checkInput(inputField) {
    inputField.value = inputField.value.trim();
    const inputClasses = inputField.classList;
    let regexList = null;
    let inputClass = "";
    for (let cls of inputClasses) {
        if (cls == "youtubeChannelName") {
            regexList = [];
            break;
        }
        if (serviceRegexMap[cls]) {
            if (cls == "youtubeChannelName") {
                regexList = [];
                break;
            }
            regexList = serviceRegexMap[cls];
            inputClass = cls;
            break;
        }
    }
    let isValid = false;
    let variant = inputField
        .closest(".service")
        ?.querySelector(".slider")
        ?.variant?.split("~")[1];
    if (variant == "shortviews" && inputClass == "youtubeViews") {
        regexList = serviceRegexMap["youtubeShortviews"];
    }
    if (Array.isArray(regexList)) {
        if (regexList.length == 0 && inputField.value.trim() !== "") {
            isValid = true;
        } else {
            for (let regex of regexList) {
                if (regex.test(inputField.value)) {
                    isValid = true;
                    break;
                }
            }
        }
    } else if (regexList) {
        isValid = regexList.test(inputField.value);
    }
    if (!isValid) {
        let fieldInfo = inputField.name;
        let formattedFieldInfo = fieldInfo.replace(/-/g, " ").toLowerCase();
        formattedFieldInfo = formattedFieldInfo.split(" ");
        if (variant) {
            formattedFieldInfo[formattedFieldInfo.length - 1] = variant;
        }
        if (formattedFieldInfo[0] == "a") {
            formattedFieldInfo = formattedFieldInfo.slice(1).join(" ");
        } else {
            formattedFieldInfo = formattedFieldInfo.join(" ");
        }
        if (
            formattedFieldInfo?.includes("/ URL") ||
            formattedFieldInfo?.includes("/ url")
        ) {
            formattedFieldInfo = formattedFieldInfo.replace(/\/\s?url/i, "");
        }
        if (inputField.value === "") {
            createToast(
                "error",
                `Please enter ${
                    formattedFieldInfo +
                    (formattedFieldInfo.includes("youtube channel name") ? " / URL" : "")
                }.`
            );
            return false;
        }
        createToast(
            "error",
            `Please enter a valid ${formattedFieldInfo}${
                formattedFieldInfo?.includes("youtube channel name") ? " / URL" : ""
            }.`
        );
        return false;
    }
    return true;
}
function handleRemoveClick() {
    const linkInputWrapper = this.closest(".link-input-wrapper");
    const linkInputs = this.closest(".link-inputs");
    const slider = this.closest(".service").querySelector(".slider");
    const sliderInfo = slider.id.split("-");
    let sliderValue = Number(slider.value);
    if (sliderValue > 0) {
        let packages = all_packages[sliderInfo[0]][sliderInfo[2]].packages.sort(
            (a, b) => a.packageQty - b.packageQty
        );
        sliderValue = packages[sliderValue - 1].packageQty;
    }
    const indicator = document.getElementById(slider.id + "-selection-indicator");
    const firstLinkInput = linkInputs.querySelector(".link-input");
    linkInputs.removeChild(linkInputWrapper);
    updateLinkInputs(
        slider,
        sliderInfo,
        linkInputs,
        indicator,
        sliderValue,
        true
    );
    handleLinkInput(firstLinkInput);
}
document.querySelectorAll(".addMore").forEach((button) => {
    button.addEventListener("click", function () {
        const linkInputs = button.previousElementSibling;
        const slider = button.closest(".service").querySelector(".slider");
        if (validateInputs(linkInputs)) {
            const sliderValueContainer = validateSlider(button, linkInputs);
            if (sliderValueContainer) {
                addNewLinkInput(slider, button, linkInputs, sliderValueContainer);
            }
        }
    });
});
function validateInputs(linkInputs) {
    const inputFields = linkInputs.querySelectorAll("input[type='text']");
    for (let inputField of inputFields) {
        if (!checkInput(inputField)) {
            inputField.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
            setTimeout(() => {
                inputField.classList.add("shake");
                setTimeout(() => {
                    inputField.classList.remove("shake");
                }, 2000);
            }, 500);
            return false;
        }
    }
    return true;
}
function validateSlider(button, linkInputs) {
    const sliderInput = button
        .closest(".service")
        .querySelector('input[type="range"]');
    let value = parseInt(sliderInput.value, 10);
    const sliderInfo = sliderInput.id.split("-");
    if (value !== 0) {
        value = sliderInput.variant
            ? Number(
                all_packages[sliderInfo[0]][sliderInfo[2]].subpackages[
                    sliderInput.variant
                    ].packages[value - 1].packageQty
            )
            : Number(
                all_packages[sliderInfo[0]][sliderInfo[2]].packages[value - 1]
                    .packageQty
            );
    }
    let variant = sliderInput.variant;
    let limit = all_packages[sliderInfo[0]][sliderInfo[2]].set_limit;
    const parentElement = sliderInput.closest(".service");
    let service_limit = parentElement.querySelector(".service-limit");
    if (variant) {
        limit =
            all_packages[sliderInfo[0]][sliderInfo[2]].subpackages[variant].set_limit;
    }
    let value1 = sliderInput.value;
    let variants =
        all_packages[sliderInfo[0]][sliderInfo[2]]?.packages[Number(value1) - 1]
            ?.variants;
    if (variants) {
        let checkedRadio = parentElement?.querySelector(".duration-radio:checked");
        if (checkedRadio) {
            let checkedValue = checkedRadio.value;
            for (let k of variants) {
                if (k.variant_name == checkedValue) {
                    if (k.variant_limit) {
                        limit = Number(k.variant_limit);
                    }
                    break;
                }
            }
        }
    }
    service_limit.innerHTML = limit;
    const maxFields = Math.floor(value / limit);
    const currentFields =
        linkInputs.querySelectorAll("input[type='text']").length;
    if (currentFields >= maxFields) {
        createToast("error", "The Minimum Quantity Per Link Is At Least " + limit);
        return false;
    }
    return value;
}
function addNewLinkInput(slider, button, linkInputs, sliderValue) {
    const linkInputsArray = Array.from(linkInputs.children);
    const lastLinkInput = linkInputsArray[linkInputsArray.length - 1];
    const sliderInfo = slider.id.split("-");
    const category = sliderInfo[0];
    const indicator = document.getElementById(slider.id + "-selection-indicator");
    const newLinkInput = lastLinkInput.cloneNode(true);
    const perPostValDiv = newLinkInput.querySelector(".per-post-val");
    newLinkInput.querySelector("input[type='text']").value = "";
    if (!lastLinkInput.querySelector(".remove-link")) {
        const newElement = document.createElement("div");
        newElement.className = `remove-link p-1 border-2 border-${category} rounded-md cursor-pointer`;
        newElement.innerHTML = `
			<svg class="fill-${category}" height="10px" width="10px" viewBox="0 0 460.775 460.775">
				<g>
					<path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
						c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
						c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
						c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
						l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
						c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"></path>
				</g>
			</svg>
		`;
        perPostValDiv.insertAdjacentElement("afterend", newElement);
    }
    let reactions = newLinkInput.querySelector(".reactions");
    if (reactions) {
        reactions.innerHTML = "";
    }
    linkInputs.appendChild(newLinkInput);
    linkInputs.querySelectorAll(".remove-link").forEach((button) => {
        button.removeEventListener("click", handleRemoveClick);
        button.addEventListener("click", handleRemoveClick);
    });
    updateLinkInputs(
        slider,
        sliderInfo,
        linkInputs,
        indicator,
        sliderValue,
        true
    );
    const accordion = button ? button.closest(".accordion") : null;
    if (accordion) {
        setTimeout(() => {
            expandAccordion(accordion);
        }, 100);
    }
    setTimeout(() => {
        newLinkInput.style.display = "block";
    }, 0);
}
